import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import * as actions from '../actions';
// import * as c from '../constant';
import StepProgress from '../components/StepProgress';

function ReadOnlyField({ label, value }) {
  return (
    <div className="mb-3">
      <div className="text-muted" style={{ fontSize: 12, fontWeight: 600 }}>
        {label}
      </div>
      <input
        className="form-control"
        value={value || 'System Data'}
        disabled
        style={{
          background: '#F2F2F2',
          border: '1px solid #E6E6E6',
          borderRadius: 6,
          height: 42,
          fontSize: 13,
        }}
      />
    </div>
  );
}

ReadOnlyField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
};

ReadOnlyField.defaultProps = {
  value: '',
};

function ReviewTransactionFeedbackModal({
  onClose,
  onProceed,
  getFeedbackFormsCore,
  // feedbackFormsCore,
  feedbackDataForFeedback,
  allowAnonymousFeedback
}) {
  const [formData, setFormData] = useState(() => ({
    ...(_.isObject(feedbackDataForFeedback) ? feedbackDataForFeedback : {}),
    is_anonymous: false,
    age: '',
    sex: '',
    gender: '',
    gender_other: '',
  }));

  const onChangeRadio = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const onChangeText = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const onToggleAnonymous = (e) => {
    const checked = !!_.get(e, 'target.checked');
    setFormData((prev) => ({ ...prev, is_anonymous: checked }));
  };

  const isFormValid = () => {
    const age = _.get(formData, 'age');
    const sex = _.get(formData, 'sex');
    const gender = _.get(formData, 'gender');
    return age && sex && gender;
  };

  useEffect(() => {
    getFeedbackFormsCore();
  }, [getFeedbackFormsCore]);

  const name = _.get(feedbackDataForFeedback, 'name', '') || '';
  const lgu_municipality_region_name = _.get(feedbackDataForFeedback, 'lgu_municipality_region_name', '') || '';
  const lgu_municipality_province_name = _.get(feedbackDataForFeedback, 'lgu_municipality_province_name', '') || '';
  const lgu_municipality_name = _.get(feedbackDataForFeedback, 'lgu_municipality_name', '') || '';
  const serviceAvailed = _.get(feedbackDataForFeedback, 'services_availed');

  return (
    <>
      <div className="modal-body" style={{ padding: 18 }}>
        <div className="font-weight-bold" style={{ fontSize: 20, lineHeight: 1.25 }}>
          Review Personal and
          <br />
          System Information
        </div>

        <StepProgress step={1} />

        <div className="mb-3 mt-2 font-weight-bold" style={{ fontSize: 14, fontWeight: 600 }}>
          Personal Information
        </div>

        <ReadOnlyField label="Name" value={name} />

        <div className="mb-3">
          <div className="text-muted" style={{ fontSize: 12, fontWeight: 600 }}>
            Age <em>(Edad)</em> <span style={{ color: '#D32F2F' }}>*</span>
          </div>
          <div className="d-flex flex-column mt-2" style={{ gap: 10 }}>
            <label className="d-flex align-items-center mb-0" style={{ gap: 10 }}>
              <input
                type="radio"
                name="age"
                style={{ width: 20, height: 20 }}
                onChange={onChangeRadio}
                checked={_.get(formData, 'age') === '18-25'}
                value="18-25"
              />
              <span>18-25</span>
            </label>

            <label className="d-flex align-items-center mb-0" style={{ gap: 10 }}>
              <input
                type="radio"
                name="age"
                style={{ width: 20, height: 20 }}
                onChange={onChangeRadio}
                checked={_.get(formData, 'age') === '26-35'}
                value="26-35"
              />
              <span>26-35</span>
            </label>

            <label className="d-flex align-items-center mb-0" style={{ gap: 10 }}>
              <input
                type="radio"
                name="age"
                style={{ width: 20, height: 20 }}
                onChange={onChangeRadio}
                checked={_.get(formData, 'age') === '36-45'}
                value="36-45"
              />
              <span>36-45</span>
            </label>

            <label className="d-flex align-items-center mb-0" style={{ gap: 10 }}>
              <input
                type="radio"
                name="age"
                style={{ width: 20, height: 20 }}
                onChange={onChangeRadio}
                checked={_.get(formData, 'age') === '46-60'}
                value="46-60"
              />
              <span>46-60</span>
            </label>

            <label className="d-flex align-items-center mb-0" style={{ gap: 10 }}>
              <input
                type="radio"
                name="age"
                style={{ width: 20, height: 20 }}
                onChange={onChangeRadio}
                checked={_.get(formData, 'age') === '60 and above'}
                value="60 and above"
              />
              <span>60 and above (60 pataas)</span>
            </label>
          </div>
        </div>

        <div className="mb-3">
          <div className="text-muted" style={{ fontSize: 12, fontWeight: 600 }}>
            Sex <span style={{ color: '#D32F2F' }}>*</span>
          </div>
          <div className="d-flex flex-column mt-2" style={{ gap: 10 }}>
            <label className="d-flex align-items-center mb-0" style={{ gap: 10 }}>
              <input
                type="radio"
                name="sex"
                style={{ width: 20, height: 20 }}
                onChange={onChangeRadio}
                checked={_.get(formData, 'sex') === 'Male'}
                value="Male"
              />
              <span>Male</span>
            </label>
            <label className="d-flex align-items-center mb-0" style={{ gap: 10 }}>
              <input
                type="radio"
                name="sex"
                style={{ width: 20, height: 20 }}
                onChange={onChangeRadio}
                checked={_.get(formData, 'sex') === 'Female'}
                value="Female"
              />
              <span>Female</span>
            </label>
          </div>
        </div>

        <div className="mb-3">
          <div className="text-muted" style={{ fontSize: 12, fontWeight: 600 }}>
            Gender <em>(Kasarian)</em> <span style={{ color: '#D32F2F' }}>*</span>
          </div>
          <div className="d-flex flex-column mt-2" style={{ gap: 14 }}>
            <label className="d-flex align-items-center mb-0" style={{ gap: 10 }}>
              <input
                type="radio"
                name="gender"
                style={{ width: 20, height: 20 }}
                onChange={onChangeRadio}
                checked={_.get(formData, 'gender') === 'Feminine'}
                value="Feminine"
              />
              <span>Feminine</span>
            </label>

            <label className="d-flex align-items-center mb-0" style={{ gap: 10 }}>
              <input
                type="radio"
                name="gender"
                style={{ width: 20, height: 20 }}
                onChange={onChangeRadio}
                checked={_.get(formData, 'gender') === 'Masculine'}
                value="Masculine"
              />
              <span>Masculine</span>
            </label>

            <label className="d-flex align-items-center" style={{ gap: 10 }}>
              <input
                type="radio"
                name="gender"
                style={{ width: 20, height: 20, minWidth: '20px' }}
                onChange={onChangeRadio}
                checked={_.get(formData, 'gender') === 'Other'}
                value="Other"
              />
              <span style={{ minWidth: 46 }}>Other:</span>
              <input
                className="form-control"
                name="gender_other"
                value={_.get(formData, 'gender_other')}
                onChange={onChangeText}
                disabled={_.get(formData, 'gender') !== 'Other'}
                style={{
                  border: 'none',
                  borderBottom: '1px dotted #C9CEDA',
                  borderRadius: 0,
                  height: 28,
                  paddingLeft: 0,
                  paddingRight: 0,
                  boxShadow: 'none',
                }}
              />
            </label>
          </div>
        </div>

        <div className="mb-3 font-weight-bold" style={{ fontSize: 14, fontWeight: 600 }}>
          System Information
        </div>

        <ReadOnlyField label="Region" value={lgu_municipality_region_name} />
        <ReadOnlyField label="Province" value={lgu_municipality_province_name} /> 
        <ReadOnlyField label="City/Municipality" value={lgu_municipality_name} />
        <ReadOnlyField label="Service Availed" value={serviceAvailed} />

        {allowAnonymousFeedback !== 0 && (
          <label className="d-flex align-items-center mb-0" style={{ gap: 8, fontSize: 12 }}>
            <input
              type="checkbox"
              checked={!!_.get(formData, 'is_anonymous')}
              onChange={onToggleAnonymous}
            />
            <span className="text-muted">Keep my feedback anonymous.</span>
          </label>
        )}
      </div>

      <div className="modal-footer gap-2">
        <button
          type="button"
          className="btn btn-dark btn-block"
          style={{ padding: '12px 16px', borderRadius: 8, fontWeight: 600 }}
          onClick={() => onProceed(formData)}
          disabled={!isFormValid()}
        >
          Proceed to Questions
        </button>
        <button
          type="button"
          className="btn btn-block btn-link text-dark"
          style={{ fontWeight: 600, textDecoration: 'none' }}
          onClick={onClose}
        >
          Skip
        </button>
      </div>
    </>
  );
}

ReviewTransactionFeedbackModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onProceed: PropTypes.func.isRequired,
  // transaction: PropTypes.instanceOf(Object),
  // profile: PropTypes.instanceOf(Object),
  getFeedbackFormsCore: PropTypes.func.isRequired,
  // feedbackFormsCore: PropTypes.instanceOf(Object),
  feedbackDataForFeedback: PropTypes.instanceOf(Object),
  allowAnonymousFeedback: PropTypes.number,
};

ReviewTransactionFeedbackModal.defaultProps = {
  // transaction: {},
  // profile: {},
  // feedbackFormsCore: null,
  feedbackDataForFeedback: null,
  allowAnonymousFeedback: 0,
};

const mapStateToProps = () => ({
  // feedbackFormsCore: _.get(api, `${c.GET_FEEDBACK_FORMS_CORE}.item`) || {},
});

const enhance = _.flowRight([connect(mapStateToProps, actions)]);

export default enhance(ReviewTransactionFeedbackModal);

